// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../fragments/commonFragments.generated';
import { PotentialOperationDetailsFragmentDoc } from '../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidPackagesPageMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BidPackagesPageMetadataQuery = { __typename?: 'Query', projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }
    | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
  >, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }> };

export type ProjectBidPackagesPageMetadata_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type ProjectBidPackagesPageMetadata_Region_Fragment = { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined };

export type ProjectBidPackagesPageMetadata_Market_Fragment = { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type ProjectBidPackagesPageMetadata_Community_Fragment = { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type ProjectBidPackagesPageMetadata_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type ProjectBidPackagesPageMetadata_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type ProjectBidPackagesPageMetadata_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type ProjectBidPackagesPageMetadata_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type ProjectBidPackagesPageMetadataFragment =
  | ProjectBidPackagesPageMetadata_StandaloneProject_Fragment
  | ProjectBidPackagesPageMetadata_Region_Fragment
  | ProjectBidPackagesPageMetadata_Market_Fragment
  | ProjectBidPackagesPageMetadata_Community_Fragment
  | ProjectBidPackagesPageMetadata_Subdivision_Fragment
  | ProjectBidPackagesPageMetadata_Lot_Fragment
  | ProjectBidPackagesPageMetadata_Structure_Fragment
  | ProjectBidPackagesPageMetadata_Unit_Fragment
;

export type BidPackageGroupsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.BidPackageGroupsFilter>;
  orderBy?: Types.InputMaybe<Types.BidPackageGroupOrderBy>;
  packageOrderBy?: Types.InputMaybe<Types.BidPackageOrderBy>;
  page?: Types.InputMaybe<Types.PageFilter>;
  costCode?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type BidPackageGroupsQuery = { __typename?: 'Query', bidPackageGroups: { __typename?: 'BidPackageGroupsPageResult', entities: Array<{ __typename?: 'BidPackageGroup', id: string, displayName: string, updatedAt: Types.Scalars['DateTime']['input'], isPlanBasedV2: boolean, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, bidPackages: Array<{ __typename?: 'BidPackage', id: string, name: string, isUnitBased: boolean, isPlanBasedV2: boolean, isMissingOptions: boolean, updatedAt: Types.Scalars['DateTime']['input'], costCodesName: string, latestVersion: { __typename?: 'BidPackageVersion', id: string, version: number, displayVersion: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, readyPlan:
              | { __typename?: 'ReadyPlan', id: string, name: string }
              | { __typename?: 'PlanPackage', id: string, name: string }
              | { __typename?: 'DesignPackage', id: string, name: string }
              | { __typename?: 'ProductOffering', id: string, name: string }
             }> }, activeBidders: Array<{ __typename?: 'BidPackageBidder', id: string, name: string, kind: Types.BidPackageBidderKind, bidContract?: { __typename?: 'BidContract', id: string, internalEstimateType?: { __typename?: 'InternalEstimateTypeDetail', code: Types.InternalEstimateType } | null | undefined } | null | undefined }>, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus, name: string }, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, projects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string, children: Array<{ __typename?: 'Community', id: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }> }
          | { __typename?: 'Community', id: string, name: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, scopeSource: { __typename?: 'BidScopeSourceDetail', code: Types.BidScopeSource }, availableUpdates: Array<{ __typename?: 'BidPackageIncomingUpdate', id: string, source: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, createdByPromotion: boolean, readyPlan:
              | { __typename?: 'ReadyPlan', id: string, name: string }
              | { __typename?: 'PlanPackage', id: string, name: string }
              | { __typename?: 'DesignPackage', id: string, name: string }
              | { __typename?: 'ProductOffering', id: string, name: string }
             } }>, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string } }>, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus, name: string } }>, pageInfo: { __typename?: 'PageInfo', totalCount: number } } };

export type BidPackageGroupDetailFragment = { __typename?: 'BidPackageGroup', id: string, displayName: string, updatedAt: Types.Scalars['DateTime']['input'], isPlanBasedV2: boolean, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, bidPackages: Array<{ __typename?: 'BidPackage', id: string, name: string, isUnitBased: boolean, isPlanBasedV2: boolean, isMissingOptions: boolean, updatedAt: Types.Scalars['DateTime']['input'], costCodesName: string, latestVersion: { __typename?: 'BidPackageVersion', id: string, version: number, displayVersion: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, readyPlan:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         }> }, activeBidders: Array<{ __typename?: 'BidPackageBidder', id: string, name: string, kind: Types.BidPackageBidderKind, bidContract?: { __typename?: 'BidContract', id: string, internalEstimateType?: { __typename?: 'InternalEstimateTypeDetail', code: Types.InternalEstimateType } | null | undefined } | null | undefined }>, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus, name: string }, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, projects: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string, children: Array<{ __typename?: 'Community', id: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }> }
      | { __typename?: 'Community', id: string, name: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    >, scopeSource: { __typename?: 'BidScopeSourceDetail', code: Types.BidScopeSource }, availableUpdates: Array<{ __typename?: 'BidPackageIncomingUpdate', id: string, source: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, createdByPromotion: boolean, readyPlan:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         } }>, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string } }>, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus, name: string } };

export type BidPackageDetailFragment = { __typename?: 'BidPackage', id: string, name: string, isUnitBased: boolean, isPlanBasedV2: boolean, isMissingOptions: boolean, updatedAt: Types.Scalars['DateTime']['input'], costCodesName: string, latestVersion: { __typename?: 'BidPackageVersion', id: string, version: number, displayVersion: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, name: string }
        | { __typename?: 'PlanPackage', id: string, name: string }
        | { __typename?: 'DesignPackage', id: string, name: string }
        | { __typename?: 'ProductOffering', id: string, name: string }
       }> }, activeBidders: Array<{ __typename?: 'BidPackageBidder', id: string, name: string, kind: Types.BidPackageBidderKind, bidContract?: { __typename?: 'BidContract', id: string, internalEstimateType?: { __typename?: 'InternalEstimateTypeDetail', code: Types.InternalEstimateType } | null | undefined } | null | undefined }>, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus, name: string }, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string, children: Array<{ __typename?: 'Community', id: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }> }
    | { __typename?: 'Community', id: string, name: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  >, scopeSource: { __typename?: 'BidScopeSourceDetail', code: Types.BidScopeSource }, availableUpdates: Array<{ __typename?: 'BidPackageIncomingUpdate', id: string, source: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, createdByPromotion: boolean, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, name: string }
        | { __typename?: 'PlanPackage', id: string, name: string }
        | { __typename?: 'DesignPackage', id: string, name: string }
        | { __typename?: 'ProductOffering', id: string, name: string }
       } }>, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string } };

export type BidPackagesPage_UpdatesFragment = { __typename?: 'BidPackageIncomingUpdate', id: string, source: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, createdByPromotion: boolean, readyPlan:
      | { __typename?: 'ReadyPlan', id: string, name: string }
      | { __typename?: 'PlanPackage', id: string, name: string }
      | { __typename?: 'DesignPackage', id: string, name: string }
      | { __typename?: 'ProductOffering', id: string, name: string }
     } };

export type BidPackagesPage_BidPackageVersionFragment = { __typename?: 'BidPackageVersion', id: string, version: number, displayVersion: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, readyPlan:
      | { __typename?: 'ReadyPlan', id: string, name: string }
      | { __typename?: 'PlanPackage', id: string, name: string }
      | { __typename?: 'DesignPackage', id: string, name: string }
      | { __typename?: 'ProductOffering', id: string, name: string }
     }> };

export type BidPackagesPage_BidPackageBidderFragment = { __typename?: 'BidPackageBidder', id: string, name: string, kind: Types.BidPackageBidderKind, bidContract?: { __typename?: 'BidContract', id: string, internalEstimateType?: { __typename?: 'InternalEstimateTypeDetail', code: Types.InternalEstimateType } | null | undefined } | null | undefined };

export type DeleteBidPackageMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteBidPackageMutation = { __typename?: 'Mutation', deleteBidPackage: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export const ProjectBidPackagesPageMetadataFragmentDoc = gql`
    fragment ProjectBidPackagesPageMetadata on Project {
  ...Named
  market {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const BidPackagesPage_BidPackageVersionFragmentDoc = gql`
    fragment BidPackagesPage_BidPackageVersion on BidPackageVersion {
  id
  version
  displayVersion
  readyPlanAggregateVersions {
    id
    displayVersion
    readyPlan {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;
export const BidPackagesPage_BidPackageBidderFragmentDoc = gql`
    fragment BidPackagesPage_BidPackageBidder on BidPackageBidder {
  id
  name
  kind
  bidContract {
    id
    internalEstimateType {
      code
    }
  }
}
    `;
export const BidPackagesPage_UpdatesFragmentDoc = gql`
    fragment BidPackagesPage_Updates on BidPackageIncomingUpdate {
  id
  source {
    id
    version
    createdByPromotion
    readyPlan {
      ...Named
    }
  }
}
    ${NamedFragmentDoc}`;
export const BidPackageDetailFragmentDoc = gql`
    fragment BidPackageDetail on BidPackage {
  id
  name
  latestVersion {
    ...BidPackagesPage_BidPackageVersion
  }
  isUnitBased
  isPlanBasedV2
  isMissingOptions
  updatedAt
  activeBidders {
    ...BidPackagesPage_BidPackageBidder
  }
  status {
    code
    name
  }
  bidPackageGroup {
    id
  }
  projects {
    ...Named
    ... on Community {
      id
      productOfferings {
        id
        status {
          code
        }
      }
    }
    ... on Market {
      id
      children {
        id
        productOfferings {
          id
          status {
            code
          }
        }
      }
    }
  }
  scopeSource {
    code
  }
  availableUpdates {
    ...BidPackagesPage_Updates
  }
  canDelete {
    ...PotentialOperationDetails
  }
  costType {
    code
    name
  }
  costCodesName
}
    ${BidPackagesPage_BidPackageVersionFragmentDoc}
${BidPackagesPage_BidPackageBidderFragmentDoc}
${NamedFragmentDoc}
${BidPackagesPage_UpdatesFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;
export const BidPackageGroupDetailFragmentDoc = gql`
    fragment BidPackageGroupDetail on BidPackageGroup {
  id
  displayName
  updatedAt
  isPlanBasedV2
  productOfferings {
    ...Named
  }
  projects {
    ...Named
  }
  bidPackages(costCode: $costCode, orderBy: $packageOrderBy) {
    ...BidPackageDetail
  }
  status {
    code
    name
  }
}
    ${NamedFragmentDoc}
${BidPackageDetailFragmentDoc}`;
export const BidPackagesPageMetadataDocument = gql`
    query BidPackagesPageMetadata {
  projects(filter: {type: [Community]}) {
    ...ProjectBidPackagesPageMetadata
  }
  costCodes(filter: {version: 2}) {
    ...Named
  }
}
    ${ProjectBidPackagesPageMetadataFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useBidPackagesPageMetadataQuery__
 *
 * To run a query within a React component, call `useBidPackagesPageMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidPackagesPageMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidPackagesPageMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useBidPackagesPageMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BidPackagesPageMetadataQuery, BidPackagesPageMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidPackagesPageMetadataQuery, BidPackagesPageMetadataQueryVariables>(BidPackagesPageMetadataDocument, options);
      }
export function useBidPackagesPageMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidPackagesPageMetadataQuery, BidPackagesPageMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidPackagesPageMetadataQuery, BidPackagesPageMetadataQueryVariables>(BidPackagesPageMetadataDocument, options);
        }
// @ts-ignore
export function useBidPackagesPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidPackagesPageMetadataQuery, BidPackagesPageMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidPackagesPageMetadataQuery, BidPackagesPageMetadataQueryVariables>;
export function useBidPackagesPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackagesPageMetadataQuery, BidPackagesPageMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidPackagesPageMetadataQuery | undefined, BidPackagesPageMetadataQueryVariables>;
export function useBidPackagesPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackagesPageMetadataQuery, BidPackagesPageMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidPackagesPageMetadataQuery, BidPackagesPageMetadataQueryVariables>(BidPackagesPageMetadataDocument, options);
        }
export type BidPackagesPageMetadataQueryHookResult = ReturnType<typeof useBidPackagesPageMetadataQuery>;
export type BidPackagesPageMetadataLazyQueryHookResult = ReturnType<typeof useBidPackagesPageMetadataLazyQuery>;
export type BidPackagesPageMetadataSuspenseQueryHookResult = ReturnType<typeof useBidPackagesPageMetadataSuspenseQuery>;
export type BidPackagesPageMetadataQueryResult = Apollo.QueryResult<BidPackagesPageMetadataQuery, BidPackagesPageMetadataQueryVariables>;
export const BidPackageGroupsDocument = gql`
    query BidPackageGroups($filter: BidPackageGroupsFilter, $orderBy: BidPackageGroupOrderBy, $packageOrderBy: BidPackageOrderBy, $page: PageFilter, $costCode: [ID!]) {
  bidPackageGroups(filter: $filter, orderBy: $orderBy, page: $page) {
    entities {
      ...BidPackageGroupDetail
    }
    pageInfo {
      totalCount
    }
  }
}
    ${BidPackageGroupDetailFragmentDoc}`;

/**
 * __useBidPackageGroupsQuery__
 *
 * To run a query within a React component, call `useBidPackageGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidPackageGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidPackageGroupsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      packageOrderBy: // value for 'packageOrderBy'
 *      page: // value for 'page'
 *      costCode: // value for 'costCode'
 *   },
 * });
 */
export function useBidPackageGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BidPackageGroupsQuery, BidPackageGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidPackageGroupsQuery, BidPackageGroupsQueryVariables>(BidPackageGroupsDocument, options);
      }
export function useBidPackageGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidPackageGroupsQuery, BidPackageGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidPackageGroupsQuery, BidPackageGroupsQueryVariables>(BidPackageGroupsDocument, options);
        }
// @ts-ignore
export function useBidPackageGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidPackageGroupsQuery, BidPackageGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidPackageGroupsQuery, BidPackageGroupsQueryVariables>;
export function useBidPackageGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackageGroupsQuery, BidPackageGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidPackageGroupsQuery | undefined, BidPackageGroupsQueryVariables>;
export function useBidPackageGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackageGroupsQuery, BidPackageGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidPackageGroupsQuery, BidPackageGroupsQueryVariables>(BidPackageGroupsDocument, options);
        }
export type BidPackageGroupsQueryHookResult = ReturnType<typeof useBidPackageGroupsQuery>;
export type BidPackageGroupsLazyQueryHookResult = ReturnType<typeof useBidPackageGroupsLazyQuery>;
export type BidPackageGroupsSuspenseQueryHookResult = ReturnType<typeof useBidPackageGroupsSuspenseQuery>;
export type BidPackageGroupsQueryResult = Apollo.QueryResult<BidPackageGroupsQuery, BidPackageGroupsQueryVariables>;
export const DeleteBidPackageDocument = gql`
    mutation DeleteBidPackage($id: ID!) {
  deleteBidPackage(input: {id: $id}) {
    emptyResult
  }
}
    `;
export type DeleteBidPackageMutationFn = Apollo.MutationFunction<DeleteBidPackageMutation, DeleteBidPackageMutationVariables>;

/**
 * __useDeleteBidPackageMutation__
 *
 * To run a mutation, you first call `useDeleteBidPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBidPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBidPackageMutation, { data, loading, error }] = useDeleteBidPackageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBidPackageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBidPackageMutation, DeleteBidPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteBidPackageMutation, DeleteBidPackageMutationVariables>(DeleteBidPackageDocument, options);
      }
export type DeleteBidPackageMutationHookResult = ReturnType<typeof useDeleteBidPackageMutation>;
export type DeleteBidPackageMutationResult = Apollo.MutationResult<DeleteBidPackageMutation>;
export type DeleteBidPackageMutationOptions = Apollo.BaseMutationOptions<DeleteBidPackageMutation, DeleteBidPackageMutationVariables>;